import React from 'react';
import { List, ListItem, MenuItem } from '@material-ui/core';
import drawUtils from '../../../pages/LessonPage/drawUtils';

const LineSizeSelectorMenu = React.forwardRef(({ selectWeight, toolWeight }, ref) => {
    return (
        <List>
            <MenuItem dense disableGutters>
                <ListItem
                    button
                    key={'1'}
                    selected={toolWeight === 1}
                    onClick={(event) => {
                        event.preventDefault();
                        selectWeight(1);
                    }}
                >
                    <div style={{ width: '50px', borderBottom: drawUtils.computeLineWidth(1) + 'px solid black' }} />
                </ListItem>
            </MenuItem>
            <MenuItem dense disableGutters>
                <ListItem
                    button
                    key={'2'}
                    selected={toolWeight === 2}
                    onClick={(event) => {
                        event.preventDefault();
                        selectWeight(2);
                    }}
                >
                    <div style={{ width: '50px', borderBottom: drawUtils.computeLineWidth(2) + 'px solid black' }} />
                </ListItem>
            </MenuItem>
            <MenuItem dense disableGutters>
                <ListItem
                    button
                    key={'3'}
                    selected={toolWeight === 3}
                    onClick={(event) => {
                        event.preventDefault();
                        selectWeight(3);
                    }}
                >
                    <div style={{ width: '50px', borderBottom: drawUtils.computeLineWidth(3) + 'px solid black' }} />
                </ListItem>
            </MenuItem>
            <MenuItem dense disableGutters>
                <ListItem
                    button
                    key={'4'}
                    selected={toolWeight === 4}
                    onClick={(event) => {
                        event.preventDefault();
                        selectWeight(4);
                    }}
                >
                    <div style={{ width: '50px', borderBottom: drawUtils.computeLineWidth(4) + 'px solid black' }} />
                </ListItem>
            </MenuItem>
            <MenuItem dense disableGutters>
                <ListItem
                    button
                    key={'5'}
                    selected={toolWeight === 5}
                    onClick={(event) => {
                        event.preventDefault();
                        selectWeight(5);
                    }}
                >
                    <div style={{ width: '50px', borderBottom: drawUtils.computeLineWidth(5) + 'px solid black' }} />
                </ListItem>
            </MenuItem>
        </List>
    );
});

export default LineSizeSelectorMenu;
